// @deprecated - Use alto/pricing/types/v3/price_type.proto for any future versions.
export const PriceTypeMap = {
    WITH_INSURANCE: 'with_insurance',
    WITHOUT_INSURANCE: 'without_insurance',
};
export const PricingScenarioMap = {
    VOUCHER_PAY: 'voucher_pay',
    CASH_LESS_THAN_INSURANCE: 'cash_less_than_insurance',
    UNAVAILABLE: 'unavailable',
    CASH_AND_CATEGORIZED_REJECT: 'cash_and_categorized_reject',
    PROGYNY: 'progyny',
};
export const LineItemTypeMap = {
    ALTO_CREDIT: 'alto_credit',
    ALTO_SAVINGS: 'alto_savings',
    CASH_PRICE: 'cash_price',
    DELIVERY_FEE: 'delivery_fee',
    ESSENTIALS_ONLY_FEE: 'essentials_only_fee',
    INSURANCE_PAID: 'insurance_paid',
    ON_DEMAND_FEE: 'on_demand_fee',
    SAME_DAY_DELIVERY_FEE: 'same_day_delivery_fee',
    TIP_AMOUNT: 'tip_amount',
    TOTAL: 'total',
    PENDING_PROGYNY_COVERAGE: 'pending_progyny_coverage',
    NEXT_DAY_DELIVERY_FEE: 'next_day_delivery_fee',
    STANDARD_DELIVERY_FEE: 'standard_delivery_fee',
    ASAP_DELIVERY_FEE: 'asap_delivery_fee',
    PICKUP: 'pickup',
};
export const LineItemInfoKeyMap = {
    ESTIMATED: 'estimated',
    PRICE_UNAVAILABLE: 'price_unavailable',
};
export const PricingEndpoint = (makeRequest) => {
    return {
        fetchPrescriptionPricing(params, options) {
            return makeRequest('GET', '/pricing/prescriptions', params, options);
        },
        fetchPrescriptionPricingById(params, options) {
            return makeRequest('GET', `/pricing/prescriptions/${params.id}`, params, options);
        },
        fetchOrderPricing(params, options) {
            return makeRequest('POST', '/pricing/order', params, options);
        },
    };
};
//# sourceMappingURL=pricing_endpoint.js.map